
import { 
  defineComponent, 
  computed, 
  SetupContext,
  PropType
} from "vue";
import NativeClient from "@/client/native-client";
import ShoppingCategoryListItem from "@/components/shoppingList/ShoppingCategoryListItem.vue";
import { ShoppingListCategoryListItem } from "@/types/shoppingList"

export default defineComponent({
  name: "ShoppingCategoryList",
  components: { ShoppingCategoryListItem },
  props: {
    /** 食材リスト */
    categoryList: {
      type: Array as PropType<ShoppingListCategoryListItem[]>,
      default: () => null
    },
    /** 食材が存在しない場合のメッセージ */
    noElementMessage: {
      type: String,
      required: true
    }
  },
  setup(props, context: SetupContext) {
    NativeClient.sendDebugLog("ShoppingCategoryList setUp start categoryList = " + JSON.stringify(props.categoryList));
    // カテゴリ
    const getCategoryList = () => {
      return props.categoryList;
    };
    const styleCategoryList = computed(() => {
      if (props.categoryList == null || props.categoryList.length == 0) {
        NativeClient.sendDebugLog("ShoppingCategoryList styleCategoryList hidden");
        return { display: `none` };
      }
      NativeClient.sendDebugLog("ShoppingCategoryList styleCategoryList normal");
      return { display: `inline-box` };
    });

    // 表示するものが存在しない場合
    const styleNoElement = computed(() => {
      NativeClient.sendDebugLog("ShoppingCategoryList styleNoElement");
      if (props.categoryList == null) {
        NativeClient.sendDebugLog("ShoppingCategoryList styleNoElement null branch");
        return { display: `table`, visibility: `hidden` };
      } else if (props.categoryList.length == 0) {
        NativeClient.sendDebugLog("ShoppingCategoryList styleNoElement no element branch");
        return { display: `table`, visibility: `visible` };
      }
      return { display: `none` };
    });

    const checkClick = (id: number, check: boolean) => {
      context.emit("check-click", id, check);
    }

    const editClick = (id: number, foodId: number) => {
      context.emit("edit-click", id, foodId);
    };

    return {
      getCategoryList,
      styleCategoryList,
      styleNoElement,
      checkClick,
      editClick
    };
  }
});
